export const css = {
	root: '_2gKd1u7h',
	' _key': 'lcc-rcs/backview'
};

export default css;
